// Une nouvelle version attend et n'est activée que sur demande (applyUpdate). Elle est gardée ici pour bootstrap.js,
// qui s'abonne après la création du store
let waitingRegistration = null;
let updateListener = null;
// Mise à jour demandée par cet onglet (bandeau, ErrorBoundary)
let isUpdateRequested = false;
const onUpdate = (registration) => {
    waitingRegistration = registration;
    updateListener?.(registration);
};

export function onUpdateAvailable(listener) {
    updateListener = listener;
    if (waitingRegistration) listener(waitingRegistration);
}

export function register() {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
        const hadController = !!navigator.serviceWorker.controller;
        let isReloading = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!hadController || isReloading) return;
            // Activée depuis un autre onglet : bandeau (qui attend la fin de la saisie) plutôt qu'un rechargement sous un formulaire ouvert
            if (!isUpdateRequested) {
                onUpdate({ waiting: null });
                return;
            }
            isReloading = true;
            window.location.reload();
        });

        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).then(registration => {
            const notifyIfWaiting = () => {
                if (registration.waiting && navigator.serviceWorker.controller) onUpdate(registration);
            };
            notifyIfWaiting();
            registration.addEventListener('updatefound', () => {
                const worker = registration.installing;
                worker?.addEventListener('statechange', () => {
                    if (worker.state === 'installed') notifyIfWaiting();
                });
            });
            setInterval(() => registration.update().catch(() => { }), 30 * 60 * 1000);
        }).catch(error => console.error('Error during service worker registration:', error));
    });
}

export function applyUpdate(registration) {
    isUpdateRequested = true;
    if (registration?.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    else window.location.reload();
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
        });
    }
}
